<template>
  <div class="group-promotions">
    <div class="group-promotions__header">
      <atomic-cat-heading :icon="getPromotionContent('promotions.icon')">
        {{ getPromotionContent('promotions.label') }}
      </atomic-cat-heading>
    </div>

    <div
      ref="sliderContainer"
      class="group-promotions__container"
    >
      <div
        v-if="getPromotionContent('promotions.cards.items')?.length"
        class="group-promotions__slider"
      >
        <ul class="group-promotions__list">
          <li
            v-for="(promotion, index) in getPromotionContent('promotions.cards.items')"
            :key="promotion.title + '-' + index"
            :style="`background-image: url(${promotion.image})`"
            class="group-promotions__item"
            @click="clickCard(index)"
          >
            <div class="group-promotions__item-content">
              <div class="group-promotions__item-sub-title">
                {{ promotion.topLabel }}
              </div>
              <div
                class="group-promotions__item-title"
                :class="{
                  'group-promotions__item-title_highlighted': index === 2,
                }"
              >
                {{ promotion.title }}
              </div>
              <div class="group-promotions__item-actions">
                <button-base
                  type="primary"
                  size="sm"
                  @click="isLoggedIn ? openWalletModal('deposit') : openModalSync(ModalName.SIGN_UP)"
                >
                  {{ promotion.buttonLabel }}
                </button-base>
                <button-base
                  type="gray"
                  size="sm"
                  @click="router.push(promotion.link.url)"
                >
                  {{ getButtonText('moreInfo') }}
                </button-base>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ModalName } from '@skeleton/consts/modals';

const router = useRouter();

const sliderContainer = ref(null);
const { getContent } = useProjectMethods();
const { globalComponentsContent, defaultLocaleGlobalComponentsContent, layoutData, defaultLocaleLayoutData }
    = storeToRefs(useGlobalStore());
const getButtonText = (key: string) => getContent(layoutData.value, defaultLocaleLayoutData.value, `buttons.${key}`);
const { isLoggedIn } = storeToRefs(useProfileStore());
const { openWalletModal } = useTransactionStore();
const { openModalSync } = useModalStore();
const { isMobile } = storeToRefs(useDeviceStore());

const hoverCard = ref<number>();

const clickCard = (index: number): void => {
  if (isMobile.value) {
    hoverCard.value = hoverCard.value === index ? undefined : index;
  }
};

const clickOutside = (e: MouseEvent): void => {
  if (e.target instanceof HTMLElement && e.target.closest('.group-promotions__item')) return;
  hoverCard.value = undefined;
};

const getPromotionContent = (key: string) =>
  getContent(globalComponentsContent.value, defaultLocaleGlobalComponentsContent.value, key);

onMounted(() => {
  document.addEventListener('click', clickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', clickOutside);
});
</script>

<style src="~/assets/styles/components/group/promotions.scss" lang="scss" />
